export const liveStore = { stream: null, liveId: null };
